import React, { useEffect, useState } from "react";
import styles from "./TiendaEnLinea.module.css";
import { DespliegueMarcas } from "./DespliegueMarcas";
import axios from "axios";
import { Paginacion } from "../Pagination/Paginacion";
import { useLocation } from "react-router-dom";
import { Card } from "../Cards/Card";
import { useSelector } from "react-redux";

// Mapeo de IDs internos de categorías
const categoriaIdMap = {
  "Capilar": "01",
  "Perfumería": "02",
  "Higiene y Cuidado de la piel": "05",
  "Maquillaje": "06",
  "Cuidado Facial": "04",
  "Bienestar": "07"
};

// Mapeo de IDs internos de marcas por nombre
const marcaIdMap = {
  "Dicora": "199",
  "Deven": "193",
  "Kanechom": "178",
  "Lattafa": "160",
  "Instituto Español": "117",
  "My Styles": "156",
  "Gigot": "174"
};

// Función para obtener la URL completa de la imagen
const getFullImageUrl = (path) => {
  if (!path) return "";
  return `${process.env.REACT_APP_API_URL}${path}`.replace(/([^:]\/)\/+/g, "$1");
};

export const SubMarcas = ({ categoria, marcas, index }) => {
  const marcasArray = Array.isArray(marcas) ? marcas : [];
  const tieneMarcas = marcasArray.length > 0;

  console.log(categoria , "categoria")

  const [data, setData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [isLoading, setIsLoading] = useState(false);
  const [desplegarMarcas, setDesplegarMarcas] = useState(
    Array(marcasArray.length).fill(false)
  );
  const [activeMarca, setActiveMarca] = useState({
    lineaId: null,
    marcaId: null,
  });
  const [inventario, setInventario] = useState(false);
  const [marca, setMarca] = useState(null);
  const { isAuthenticated, token, user, userType } = useSelector(
    (state) => state.auth
  );
  const [pedidos, setPedidos] = useState([]);
  const [marcaGuardada, setMarcaGuardada] = useState(null);

  const location = useLocation();

  const peticion = async () => {
    setIsLoading(true);
    try {
      let response;
      if (tieneMarcas) {
        if (!activeMarca.lineaId || !activeMarca.marcaId) return;
        response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/productos/filter?linea_id=${activeMarca.lineaId}&page=${currentPage}&pageSize=4&marca_id=${activeMarca.marcaId}`
        );
      } else {
        response = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/productos/categoria?id=${categoria.id}&page=${currentPage}&pageSize=4`
        );
      }
      setData(response.data.detalle);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      console.error("Error al cargar los productos:", error);
      setData([]);
    } finally {
      setIsLoading(false);
    }
  };

  const handlePageChange = (newPage) => {
    if (!isLoading) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => {
    const delayedPeticion = () => {
      setTimeout(() => {
        if (!tieneMarcas || (activeMarca.lineaId && activeMarca.marcaId)) {
          peticion();
        }
      }, 1000);
    };
    delayedPeticion();
  }, [currentPage, activeMarca.lineaId, activeMarca.marcaId]);

  const handleDespegar = (indexMarca) => {
    const marcaSeleccionada = marcasArray[indexMarca];
    const categoriaNombre = categoria.titulo;
    const categoriaId = categoriaIdMap[categoriaNombre];
    const marcaId = marcaIdMap[marcaSeleccionada.nombres] || marcaSeleccionada.marcaId;
    const newDesplegarMarcas = desplegarMarcas.map((_, idx) => idx === indexMarca ? !desplegarMarcas[idx] : false);
    setDesplegarMarcas(newDesplegarMarcas);
    if (!desplegarMarcas[indexMarca]) {
      setActiveMarca({ lineaId: categoriaId, marcaId: marcaId });
      setCurrentPage(1);
    }
  };

  // Petición de productos: solo si NO hay marcas, o al desplegar una marca
  useEffect(() => {
    const categoriaNombre = categoria.titulo;
    const categoriaId = categoriaIdMap[categoriaNombre];
    if (marcasArray.length === 0) {
      // Si no hay marcas, mostrar productos de la categoría
      const fetchProductosCategoria = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/productos/filter?linea_id=${categoriaId}&page=${currentPage}&pageSize=4`
          );
          setData(Array.isArray(response.data.detalle) ? response.data.detalle : []);
          setTotalPages(response.data.totalPages);
        } catch (error) {
          setData([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchProductosCategoria();
    } else if (activeMarca.lineaId && activeMarca.marcaId) {
      // Si hay marcas, solo mostrar productos al desplegar una marca
      const fetchProductosMarca = async () => {
        setIsLoading(true);
        try {
          const response = await axios.get(
            `${process.env.REACT_APP_API_URL}/api/productos/filter?linea_id=${activeMarca.lineaId}&page=${currentPage}&pageSize=4&marca_id=${activeMarca.marcaId}`
          );
          setData(Array.isArray(response.data.detalle) ? response.data.detalle : []);
          setTotalPages(response.data.totalPages);
        } catch (error) {
          setData([]);
        } finally {
          setIsLoading(false);
        }
      };
      fetchProductosMarca();
    } else {
      // Si hay marcas pero ninguna está desplegada, limpiar productos
      setData([]);
    }
  }, [currentPage, activeMarca, marcasArray.length, categoria]);

  // Renderizado de productos: solo si no hay marcas, o si hay una marca desplegada
  const renderCards = () => {
    if (!Array.isArray(data) || data.length === 0) {
      return <h2 className={styles.cargando}>¡Pronto tendremos productos para ti en esta marca!</h2>;
    }
    return data.map((ele, idx) => <Card key={idx} data={ele} />);
  };

  useEffect(() => {
    if (tieneMarcas) {
      const savedMarca = JSON.parse(localStorage.getItem("activeMarca"));
      if (savedMarca && savedMarca.lineaId === categoria.id) {
        setActiveMarca(savedMarca);
        setMarcaGuardada(savedMarca);
        const element = document.getElementById(categoria.idScroll);
        if (element) {
          element.scrollIntoView({ behavior: "smooth" });
        }
      }
    }

    const element = document.getElementById(location.hash.substring(1));
    if (element) {
      setTimeout(() => {
        element.scrollIntoView({ behavior: "smooth" });
      }, 2000);
    }
  }, [location]);

  useEffect(() => {
    const storedMarca = JSON.parse(localStorage.getItem('marca'));
    if (storedMarca) {
      setMarca(storedMarca);
    }
  }, []);

  useEffect(() => {
    if (marcaGuardada) {
      const elemento = document.getElementById("marca-seleccionada");
      if (elemento) {
        elemento.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }
  }, [marcaGuardada]);
  console.log(marcasArray , "marcasArray")

  return (
    <>
      <div
        className={`${styles.contenedorMarcas} ${index % 2 !== 0 ? styles.marcasInvertida : ""} ${!tieneMarcas ? styles.sinMarcas : ""}`}
        id={categoria.idScroll}
      >
        {tieneMarcas ? (
          <>
            <div className={styles.contenedorImg}>
              <img
                className={`${styles.imgPrincipal} ${index === 1 && styles.claseEspecial}`}
                src={getFullImageUrl(categoria.imagenPrincipal)}
                alt={categoria.titulo}
              />
            </div>
            <div className={`${styles.contenedorDescripcion}`}>
              <h2 className={styles.titulo}>{categoria.titulo}</h2>
              <p className={styles.parrafo}>{categoria.description}</p>
              <>
                <h2 className={styles.marcas}>Marcas</h2>
                <p className={styles.linea}></p>
                <div className={styles.containerDespligue}>
                  {marcasArray.map((item, index) => (
                    <div key={index}>
                      <DespliegueMarcas
                        categorias={item}
                        desplegar={desplegarMarcas[index]}
                        handleDespegar={() => handleDespegar(index)}
                      />
                    </div>
                  ))}
                </div>
              </>
            </div>
          </>
        ) : (
          <>
            <div className={styles.contenedorImg}>
              <img
                className={`${styles.imgPrincipal}`}
                src={categoria.imagenPrincipal}
                alt={categoria.titulo}
              />
            </div>
            <div className={styles.contenedorDescripcion}>
              <h2 className={styles.titulo}>{categoria.titulo}</h2>
              <p className={styles.parrafo}>{categoria.description}</p>
            </div>
          </>
        )}
      </div>

      <div className={styles.contenedorProductos}>
        {marcasArray.length === 0 && (isLoading ? (
          <h2 className={styles.cargando}>Cargando...</h2>
        ) : (
          renderCards()
        ))}
      </div>
      {marcasArray.length === 0 && data.length > 0 && (
        <Paginacion
          totalPages={totalPages}
          currentPage={currentPage}
          onPageChange={handlePageChange}
        />
      )}

      {tieneMarcas && (
        marcasArray.map(
          (item, index) =>
            desplegarMarcas[index] && (
              <div key={`marca-${index}`}>
                <div className={`${styles.contenedorDesplegado} ${styles.abierto}`}>
                  <img
                    className={styles.imgMarcaDesplegado}
                    src={getFullImageUrl(item.imagenMarcas[0].img)}
                    alt={item.nombres}
                  />
                  <div className={styles.contenedorDescripcionDesplegado}>
                    <h2 className={styles.tituloDesplegado}>{item.nombres}</h2>
                    <p className={styles.parrafoDesplegado}>
                      {item.marcaDescription}
                    </p>
                  </div>
                  <div className={styles.cetificacionesColum}>
                    {item.imgCertificaciones.length > 0 && (
                      <h3 className={styles.tituloCerrtificaciones}>
                        Certificaciones
                      </h3>
                    )}
                    <div
                      className={
                        item.imgCertificaciones.length > 3
                          ? `${styles.imgsCertificados} ${styles.certificadosColumna}`
                          : styles.imgsCertificados
                      }
                    >
                      {item.imgCertificaciones.map((imgs, imgIndex) => (
                        <img
                          key={imgIndex}
                          className={styles.imgDesplegado}
                          src={getFullImageUrl(imgs)}
                          alt="Certificación"
                        />
                      ))}
                    </div>
                  </div>
                </div>
                <div className={styles.contenedorProductos}>
                  {isLoading ? (
                    <h2 className={styles.cargando}>Cargando...</h2>
                  ) : (
                    renderCards()
                  )}
                </div>
                <Paginacion
                  totalPages={totalPages}
                  currentPage={currentPage}
                  onPageChange={handlePageChange}
                />
              </div>
            )
        )
      )}

      {index !== categoria.length - 1 && (
        <div className={styles.lineaDivisoria}></div>
      )}
    </>
  );
};
